// SPDX-License-Identifier: BUSL-1.1; Copyright (c) 2025 Social Connect Labs, Inc.; Licensed under BUSL-1.1 (see LICENSE); Apache-2.0 from 2029-06-11

// src/adapters/browser/haptic.ts
function createNoOpHapticAdapter() {
  return (_type, _options) => {
  };
}

// src/adapters/browser/analytics.ts
function createWebAnalyticsAdapter(options) {
  const { endpoint, debug = false } = options ?? {};
  function send(payload) {
    if (debug) {
      console.log("[Analytics]", payload);
    }
    if (endpoint) {
      fetch(endpoint, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload)
      }).catch(() => {
      });
    }
  }
  return {
    trackEvent(event, payload) {
      send({ type: "event", event, ...payload, timestamp: Date.now() });
    },
    trackNfcEvent(name, properties) {
      send({ type: "nfc_event", name, ...properties, timestamp: Date.now() });
    },
    logNFCEvent(level, message, context, details) {
      send({ type: "nfc_log", level, message, context, details, timestamp: Date.now() });
    }
  };
}

// src/adapters/browser/crypto.ts
function normalizeAlgo(algo) {
  return algo.toUpperCase().replace(/^SHA(\d)/, "SHA-$1");
}
function createWebCryptoAdapter() {
  return {
    async hash(input, algo = "sha256") {
      const webCryptoAlgo = normalizeAlgo(algo);
      const digest = await crypto.subtle.digest(webCryptoAlgo, input);
      return new Uint8Array(digest);
    },
    async sign(_data, _keyRef) {
      throw new Error(
        "Signing is not implemented in the browser crypto adapter. Signing requires native keychain access via the bridge."
      );
    },
    async generateKey(_keyRef) {
      throw new Error(
        "Key generation is not implemented in the browser crypto adapter. Key generation requires native keychain access via the bridge."
      );
    },
    async getPublicKey(_keyRef) {
      throw new Error(
        "Public key retrieval is not implemented in the browser crypto adapter. Public key retrieval requires native keychain access via the bridge."
      );
    }
  };
}

// src/adapters/browser/network.ts
function createWebNetworkAdapter() {
  return {
    http: {
      fetch: (input, init) => fetch(input, init)
    },
    ws: {
      connect: (url) => {
        const socket = new WebSocket(url);
        return {
          send: (data) => socket.send(data),
          close: () => socket.close(),
          onMessage: (cb) => {
            socket.addEventListener("message", (ev) => cb(ev.data));
          },
          onError: (cb) => {
            socket.addEventListener("error", (e) => cb(e));
          },
          onClose: (cb) => {
            socket.addEventListener("close", () => cb());
          }
        };
      }
    }
  };
}

export {
  createNoOpHapticAdapter,
  createWebAnalyticsAdapter,
  createWebCryptoAdapter,
  createWebNetworkAdapter
};
//# sourceMappingURL=chunk-5SUWNSYF.js.map